const global = window

// Remplissage automatique
inputs.behavior.popup = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.popup) {
        input.click(function(event) {
            if (!input.data('hold')) {
                ajaxPopup(data.popup.title, data.popup.width ? data.popup.width : 950, data.popup.height ? data.popup.height : 750, data.popup.url, null, (popup) => {inputReloadParent(this, popup)}, data.popup.icon, event);
            }
        })
    }
    return data
}
